export default "__VITE_ASSET__CDVED2qK__"